import * as Yup from "yup";
import {
  TBitValue,
  TReactSetState,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  handleError,
  prepareMessageFromParams,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  CREATE_TAX_CATEGORY,
  GET_TAX_CATEGORY_BY_ID,
  UPDATE_TAX_CATEGORY,
} from "../../services/Endpoints";
import { BIT_VALUE } from "../../utils/AppEnumerations";

export interface ITaxCategoryForm {
  id?: string;
  category_name: string;
  can_individual_assign_to_item: TBitValue;
  created_by?: string;
  modified_by?: string;
  created_date?: string;
  modified_date?: string;
}

export const TAX_CATEGORY_INITIAL_VALUES = {
  category_name: "",
  can_individual_assign_to_item: BIT_VALUE.Zero,
};

export const taxCategoryValidationSchema = (t: TUseTranslationTfn) =>
  Yup.object().shape({
    category_name: Yup.string()
      .required(
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("category_name")],
        ])
      )
      .max(
        50,
        prepareMessageFromParams(t("error_message_max_length"), [
          ["fieldName", t("category_name")],
          ["max", "50"],
        ])
      )
      .min(
        2,
        prepareMessageFromParams(t("error_message_min_length"), [
          ["fieldName", t("category_name")],
          ["min", "2"],
        ])
      ),
  });

export const fetchTaxCategoryById = async (
  id: string,
  handleClose: (status: boolean) => void,
  setTaxCategory: TReactSetState<ITaxCategoryForm | undefined>
) => {
  try {
    const taxCategoryFieldData = await GET_TAX_CATEGORY_BY_ID(id);
    if (
      taxCategoryFieldData &&
      taxCategoryFieldData.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      setTaxCategory(taxCategoryFieldData.data);
    } else {
      handleClose(false);
      sweetAlertError({
        message: taxCategoryFieldData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleClose(false);
    handleError(e, "fetchTaxCategoryById");
  }
};

export const handleSubmitTaxCategory = async (
  values: ITaxCategoryForm,
  setLoading: TReactSetState<boolean>,
  id: string | undefined,
  handleClose: (status: boolean) => void
) => {
  setLoading(true);
  try {
    let resultTaxCategory;
    if (id) {
      resultTaxCategory = await UPDATE_TAX_CATEGORY(values, id);
    } else {
      resultTaxCategory = await CREATE_TAX_CATEGORY(values);
    }
    if (
      resultTaxCategory &&
      resultTaxCategory.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      sweetAlertSuccess({
        message: resultTaxCategory.message,
      });
      return handleClose(true);
    } else {
      sweetAlertError({
        message: resultTaxCategory?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleError(e, "handleSubmitTaxCategory");
  } finally {
    setLoading(false);
  }
};
